import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import OneClickButton from '../../../../components/form/button';
import {
  Panel, PanelHeader, PanelBody, PanelFooter,
} from '../../../../components/panel/panel';
import addNotification from '../../../../components/notification';
import ROUTES from '../../../../config/routes';
import {
  createPriority, updatePriority, getPriority,
} from '../../../../app/store/actions/priorities';
import Form from '../../../../components/form/form';
import PriorityHelpers from '../../../../helpers/priority';

class PriorityForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: 'detail',
      code: '',
      name: '',
      sequence: 0,
      status: 1,
      note: '',
      disableCode: true,
      disableName: true,
      disableSequence: true,
      disableStatus: true,
      disableNote: true,
      showCreate: false,
      showUpdate: false,
      showCancel: false,
    };
  }

  async componentDidMount() {
    await this.setMode();
    if (this.state.mode !== 'create') {
      await this.getPrioritySelected(false);
    }
  }

  getPrioritySelected = async () => {
    if (this.props.location.state.priority) {
      const { priority } = this.props.location.state;
      const prioritySelected = await priority;

      if (prioritySelected) {
        this.setState({
          priorityId: prioritySelected.id,
          code: prioritySelected.code,
          name: prioritySelected.name,
          sequence: prioritySelected.sequence,
          status: prioritySelected.status,
          note: prioritySelected.note,
          disableSequence: prioritySelected.status !== 1,
        });
      }
    }
  };

  setMode = () => {
    let mode;
    if (this.props.isCreate) mode = 'create';
    else if (this.props.isCopy) mode = 'copy';
    else if (this.props.isEdit) mode = 'edit';
    else if (this.props.isDetail) mode = 'detail';
    else mode = '';

    if (mode === 'create' || mode === 'copy') {
      this.setState({
        mode,
        disableCode: false,
        disableName: false,
        disableSequence: false,
        disableNote: false,
        disableStatus: false,
        showCreate: true,
        showUpdate: false,
        showCancel: true,
      });
    } else if (mode === 'edit') {
      this.setState({
        mode,
        disableCode: true,
        disableName: false,
        disableSequence: false,
        disableStatus: false,
        disableNote: false,
        showCreate: false,
        showUpdate: true,
        showCancel: true,
      });
    }
  };

  setValue = async (attr, value) => {
    console.log(attr, value);
    await this.setState({
      [`${attr}`]: value,
    });

    if (attr === 'status') {
      if (parseInt(value, 10) === 1) {
        this.setState({
          disableSequence: false,
        });
      } else {
        this.setState({
          disableSequence: true,
          sequence: 0,
        });
      }
    }
  };

  createPrioritySubmit = async () => {
    const {
      code, name, note, status, sequence,
    } = this.state;

    try {
      const newPriority = await this.props.createPriority({
        code,
        name,
        note,
        status,
        sequence,
      });

      if (newPriority) {
        await addNotification(
          'success',
          I18n.t('BEE626' /* Prioridades */),
          I18n.t('BEE650', { 0: code } /* Prioridade %{0} incluída com sucesso! */),
          'top-right',
        );

        this.props.history.push(ROUTES.PRIORITY_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE626' /* Prioridades */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE626' /* Prioridades */),
            I18n.t('BEE651', { 0: code } /* Erro ao incluir a prioridade %{0} */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE626' /* Prioridades */),
          I18n.t('BEE651', { 0: code } /* Erro ao incluir a prioridade %{0} */),
          'top-right',
        );
      }
    }
  };

  updatePrioritySubmit = async () => {
    const {
      code, name, note, priorityId, status, sequence,
    } = this.state;

    try {
      const updPriority = await this.props.updatePriority({
        priorityId,
        name,
        note,
        status,
        sequence,
      });

      if (updPriority) {
        await addNotification(
          'success',
          I18n.t('BEE652' /* Atualizar Prioridade */),
          I18n.t('BEE653', { 0: code } /* Prioridade %{0} atualizada com sucesso! */),
          'top-right',
        );

        this.props.history.push(ROUTES.PRIORITY_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE652' /* Atualizar Prioridade */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE652' /* Atualizar Prioridade */),
            I18n.t('BEE654', { 0: code } /* Erro ao atualizar a prioridade %{0} */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE652' /* Atualizar Prioridade */),
          I18n.t('BEE654', { 0: code } /* Erro ao atualizar a prioridade %{0} */),
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      code, name, sequence, note, status,
    } = this.state;

    const {
      mode, disableCode, disableName, disableSequence, disableNote, showCreate, showUpdate, showCancel,
      disableStatus,
    } = this.state;

    let title = '';
    let breadActive = '';

    if (mode === 'create' || mode === 'copy') {
      title = I18n.t('BEE644' /* Nova Prioridadde */);
    } else if (mode === 'edit') {
      title = I18n.t('BEE645' /* Editar Prioridade */);
      breadActive = `${code} - ${name}`;
    } else if (mode === 'detail') {
      title = I18n.t('BEE646' /* Detalhes Prioridade */);
      breadActive = `${code} - ${name}`;
    }

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1389' /* Cadastros */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE626' /* Prioridades */)}</li>
            <li className="breadcrumb-item active">{breadActive}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {title}
          </h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <form>
              <Panel>
                <PanelHeader noButton />
                <PanelBody>
                  <Form
                    noPanel
                    setValue={this.setValue}
                    inputs={(formContext) => ([
                      formContext.createInput(
                        code,
                        'code',
                        `${I18n.t('BEE82' /* Código */)}:`,
                        I18n.t('BEE3703' /* Informe a prioridade */),
                        'text',
                        true,
                        disableCode,
                      ),
                      formContext.createInput(
                        name,
                        'name',
                        `${I18n.t('BEE83' /* Nome */)}:`,
                        I18n.t('BEE3704' /* Informe o nome da prioridade */),
                        'text',
                        true,
                        disableName,
                      ),
                      formContext.createNumberFormat(
                        sequence,
                        'sequence',
                        `${I18n.t('BEE494' /* Sequencia */)}:`,
                        0,
                        disableSequence,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        false,
                        true,
                        false,
                        false,
                        true,
                        true,
                        999,
                      ),
                      formContext.createSelect(
                        status,
                        'status',
                        `${I18n.t('BEE224' /* Status */)}:`,
                        PriorityHelpers.listPriorityStatus(),
                        disableStatus,
                      ),
                      formContext.createInput(
                        note,
                        'note',
                        `${I18n.t('BEE135' /* Observação */)}:`,
                        I18n.t('BEE136' /* Informe a observação */),
                        'text',
                        false,
                        disableNote,
                      ),
                    ])}
                  />
                </PanelBody>
                <PanelFooter>
                  <Link to={{ pathname: ROUTES.PRIORITY_LIST, state: { dice: this.props.location.dice } }}>
                    {(showCancel
                      ? (
                        <OneClickButton type="submit" className="btn btn-120 btn-white p-5 m-5">
                          {
                          I18n.t('BEE99' /* Cancelar */)
                          }
                        </OneClickButton>
                      )
                      : (
                        <OneClickButton type="submit" className="btn btn-120 btn-white p-5 m-5">
                          {
                          I18n.t('BEE137' /* Voltar */)
                          }
                        </OneClickButton>
                      ))}
                  </Link>
                  {(showCreate
                    && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.createPrioritySubmit()}
                    >
                      {I18n.t('BEE138' /* Criar */)}
                    </OneClickButton>
                    )
                  )}
                  {(showUpdate
                    && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.updatePrioritySubmit()}
                    >
                      {I18n.t('BEE139' /* Atualizar */)}
                    </OneClickButton>
                    )
                  )}
                </PanelFooter>
              </Panel>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  getPriority: (depositId) => dispatch(getPriority(depositId)),
  createPriority: (deposit) => dispatch(createPriority(deposit)),
  updatePriority: (deposit) => dispatch(updatePriority(deposit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PriorityForm));
